import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ChevronDown, ChevronUp } from 'lucide-react';
import { certGetReportTypes } from '../../services/reportingHubApi';

const CertificationHome = () => {
  const navigate = useNavigate();
  const [reportTypes, setReportTypes] = useState([]);
  const [selected, setSelected] = useState('');
  const [isFocused, setIsFocused] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    certGetReportTypes()
      .then((d) => setReportTypes(d.reportTypes || []))
      .catch(() => setReportTypes([]));
  }, []);

  const proceed = (key) => {
    if (key) navigate(`/reporting-hub/certification/search?type=${key}`);
  };

  return (
    <div className="min-h-screen bg-black text-white px-3 py-4 sm:px-4 sm:py-5 md:px-6 md:py-6 lg:px-8">
      <div className="w-full mx-auto">
        <div className="flex items-center gap-2 sm:gap-3 pb-3 sm:pb-4 border-b border-gray-400 mb-5 sm:mb-10 sm:-ml-4 -ml-2">
          <button
            onClick={() => navigate('/project-reporting')}
            className="p-1 sm:p-2 rounded-full hover:bg-gray-800 transition-colors flex-shrink-0"
            aria-label="Go back"
          >
            <ArrowLeft className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
          </button>

          <h1 className="text-sm sm:text-lg md:text-2xl lg:text-2xl xl:text-2xl font-bold leading-tight break-words">
            Project Reporting Hub_Certification
          </h1>
        </div>


        <label className="block text-xs sm:text-lg md:text-lg font-semibold mb-2">
          Step 1 : Select report type
        </label>

        <div className="relative w-full">
          <select
            value={selected}
            onClick={() => setIsOpen((prev) => !prev)}
            onBlur={() => setIsOpen(false)}
            onChange={(e) => {
              setSelected(e.target.value);
              setIsOpen(false);
              proceed(e.target.value);
            }}
            className="
      w-full
      bg-gray-900
      border border-gray-700
      rounded-lg
      px-3 sm:px-4
      py-2.5 sm:py-4
      pr-10
      text-xs sm:text-base md:text-base
      text-white
      outline-none
      focus:ring-2
      focus:ring-blue-500
      appearance-none
      cursor-pointer
    "
          >
            <option value="">-- Select report type --</option>

            {reportTypes.map((rt) => (
              <option key={rt.key} value={rt.key}>
                {rt.label}
              </option>
            ))}
          </select>
          <div
            className="
    absolute
    right-2 sm:right-3 md:right-4
    top-1/2
    -translate-y-1/2
    pointer-events-none
  "
          >
            {isOpen ? (
              <ChevronUp
                className="
        w-5 h-5
        sm:w-5 sm:h-5
        md:w-5 md:h-5
        lg:w-6 lg:h-6
        text-white
      "
              />
            ) : (
              <ChevronDown
                className="
        w-5 h-5
        sm:w-5 sm:h-5
        md:w-5 md:h-5
        lg:w-6 lg:h-6
        text-white
      "
              />
            )}
          </div>
        </div>

        {!selected && (
          <div className="mt-12 flex justify-center sm:pt-40  pt-25">
            <div className="max-w-2xl text-center border border-gray-700 rounded-xl bg-gray-900/50 px-6 py-8">

              <p className="text-sm sm:text-base text-gray-300 ">
                Select a report type from the dropdown above to continue.
                Once selected, you will be redirected to the corresponding
                report search page.w
              </p>


            </div>
          </div>
        )}

      </div>
    </div>

  );
};

export default CertificationHome;
